module.exports = __webpack_public_path__ + "static/media/29.f97a27bf.jpg";